/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_ADMIN_ROLES_FAILURE,
  CREATE_ADMIN_ROLES_REQUEST,
  CREATE_ADMIN_ROLES_SUCCESS,
  EDIT_ADMIN_USER_ROLES_FAILURE,
  EDIT_ADMIN_USER_ROLES_REQUEST,
  EDIT_ADMIN_USER_ROLES_SUCCESS,
  GET_MODULES_FOR_CLIENT_ROLE_FAILURE,
  GET_MODULES_FOR_CLIENT_ROLE_REQUEST,
  GET_MODULES_FOR_CLIENT_ROLE_SUCCESS,
  GET_MODULES_FOR_CREATE_FAILURE,
  GET_MODULES_FOR_CREATE_REQUEST,
  GET_MODULES_FOR_CREATE_SUCCESS,
  GET_SUB_MODULES_FOR_CLIENT_ROLE_FAILURE,
  GET_SUB_MODULES_FOR_CLIENT_ROLE_REQUEST,
  GET_SUB_MODULES_FOR_CLIENT_ROLE_SUCCESS,
} from "./clientRolesTypes";
let userManagementUrl = Config.userManagementUrl;
const getModuleForCreateRoleInClientRequest = () => {
  return {
    type: GET_SUB_MODULES_FOR_CLIENT_ROLE_REQUEST,
  };
};

const getModuleForCreateRoleInClientSuccess = (payload) => {
  return {
    type: GET_SUB_MODULES_FOR_CLIENT_ROLE_SUCCESS,
    payload: payload,
  };
};

const getModuleForCreateRoleInClientFaliure = (error) => {
  return {
    type: GET_SUB_MODULES_FOR_CLIENT_ROLE_FAILURE,
    payload: error,
  };
};

const getModuleForCreateRoleInClient = (roleId, clientId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getModuleForCreateRoleInClientRequest());
    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view?role_id=${roleId}&client_id=${clientId}`;
    // let url = `${userManagementUrl}/roles/get_actions_for_role_creation?role_id=${roleId}&client_id=${clientId}`;
    let url = `${userManagementUrl}/roles/get_actions_for_role_creation?role_id=${roleId}&client_id=${clientId}`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getModuleForCreateRoleInClientSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        dispatch(getModuleForCreateRoleInClientFaliure(err.message));
        return { status: false, data: err.message };
      });
  };
};

const createAdminRolesRequest = () => {
  return {
    type: CREATE_ADMIN_ROLES_REQUEST,
  };
};

const createAdminRolesSuccess = (payload) => {
  return {
    type: CREATE_ADMIN_ROLES_SUCCESS,
    payload: payload,
  };
};

const createAdminRolesFaliure = (error) => {
  return {
    type: CREATE_ADMIN_ROLES_FAILURE,
    payload: error,
  };
};

const createAdminRoles = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createAdminRolesRequest());
    let url = `${userManagementUrl}/roles/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createAdminRolesSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createAdminRolesFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getAdminModuleForViewRequest = () => {
  return {
    type: GET_MODULES_FOR_CLIENT_ROLE_REQUEST,
  };
};

const getAdminModuleForViewSuccess = (payload) => {
  return {
    type: GET_MODULES_FOR_CLIENT_ROLE_SUCCESS,
    payload: payload,
  };
};

const getAdminModuleForViewFaliure = (error) => {
  return {
    type: GET_MODULES_FOR_CLIENT_ROLE_FAILURE,
    payload: error,
  };
};

const getAdminModuleForView = (roleId, clientId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAdminModuleForViewRequest());
    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view?role_id=${roleId}&client_id=${clientId}&admin_role_id=${adminRoleId}`;
    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view?role_id=${roleId}&client_id=${clientId}`;
    let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view?role_id=${roleId}&client_id=${clientId}`;

    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view_for_users?role_id=${roleId}&client_id=${clientId}&admin_role_id=${adminRoleId}`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAdminModuleForViewSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getAdminModuleForViewFaliure(err.message));
        return { status: false, data: err.message };
      });
  };
};
const getModulesForCreateRequest = () => {
  return {
    type: GET_MODULES_FOR_CREATE_REQUEST,
  };
};

const getModulesForCreateSuccess = (payload) => {
  return {
    type: GET_MODULES_FOR_CREATE_SUCCESS,
    payload: payload,
  };
};

const getModulesForCreateFaliure = (error) => {
  return {
    type: GET_MODULES_FOR_CREATE_FAILURE,
    payload: error,
  };
};

const getModulesForCreate = (roleId, clientId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getModulesForCreateRequest());
    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view?role_id=${roleId}&client_id=${clientId}&admin_role_id=${adminRoleId}`;
    let url = `${userManagementUrl}/roles/get_mapping_for_admin?role_id=${roleId}`;
    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view?role_id=${roleId}&client_id=${clientId}`;

    // let url = `${userManagementUrl}/roles/get_accesses_by_role_for_view_for_users?role_id=${roleId}&client_id=${clientId}&admin_role_id=${adminRoleId}`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getModulesForCreateSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getModulesForCreateFaliure(err.message));
        return { status: false, data: err.message };
      });
  };
};

const editUserRolesForAdminRequest = () => {
  return {
    type: EDIT_ADMIN_USER_ROLES_REQUEST,
  };
};

const editUserRolesForAdminSuccess = (payload) => {
  return {
    type: EDIT_ADMIN_USER_ROLES_SUCCESS,
    payload: payload,
  };
};

const editUserRolesForAdminFaliure = (error) => {
  return {
    type: EDIT_ADMIN_USER_ROLES_FAILURE,
    payload: error,
  };
};

const editUserRolesForAdmin = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editUserRolesForAdminRequest());
    let url = `${userManagementUrl}/roles/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editUserRolesForAdminSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editUserRolesForAdminFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createAdminRoles,
  editUserRolesForAdmin,
  getAdminModuleForView,
  getModuleForCreateRoleInClient,
  getModulesForCreate,
};
